









































import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";
import VueElementLoading from 'vue-element-loading'; // https://www.npmjs.com/package/vue-element-loading
import { AA } from "@/lib/mixin";
import ArticleList from '@/components/ArticleList.vue';
import { AbsCatalog, Catalog } from '@/shared/catalog.model';
import { getArticles } from '@/shared/api';
const DEFAULT_PAGE_SIZE = 10

@Component({
  components: { VueElementLoading, ArticleList }
})
export default class TrainingMenu extends Mixins(Vue, AA) {
  @Prop() readonly catalog?: AbsCatalog;
  @Prop() tabIndex!: number;

  page = 0;
  articles: Array<Article> = [];
  totalCount = 0;
  selectedCategoryIndex = 0;
  isActive = false;
  showPad = false;
  needShowNav = true;
  needShowPad = false;
  itemtype = "";
  isMounted = false;

  get catalogs(): AbsCatalog[] {
    return this.catalog?.catalogs ?? [];
  }

  get categories(): AbsCatalog[] {
    return this.catalog?.catalogs?.filter(v => v.type === 'CATEGORY') ?? [];
  }

  get selectedCategory(): AbsCatalog {
    return this.categories.length > this.selectedCategoryIndex ? this.categories[this.selectedCategoryIndex] : new Catalog();
  }

  @Watch('catalog')
  catalogChanged(newVal: AbsCatalog) {
    if (newVal && this.isMounted) {
      this.page = 0
      setTimeout(this.setupData, 50)
    }
  }

  @Watch('selectedCategory')
  onSelectedCategoryChanged(newValue: AbsCatalog, oldValue: AbsCatalog) {
    window.sessionStorage.setItem('currentCatalog', newValue.title??'')
    if (newValue.id !== oldValue.id) {
      this.page=0
      this.getData(newValue)}
  }

  togglePad () {
    this.showPad = !this.showPad
    this.$emit('showPad', this.showPad)
  }

  getData(catalog: AbsCatalog, pageNum = 0, pageSize=DEFAULT_PAGE_SIZE) {
    this.isActive = true
    if (pageNum === 0) {
      this.articles = []
      catalog.articles = []
      this.totalCount = 0
    }
    this.itemtype = (this.categories.find(x=>x.id === catalog.id && x.selected === true) || this.categories.find(x=>x.id === catalog.id))?.title as string
    // let currentSearchCount = pageSize
    if (!this.itemtype) return Promise.resolve()
    return getArticles(catalog.id || 0, pageNum, pageSize).then(res => {
      this.isActive = false;
      this.totalCount = parseInt(res.count);
      this.articles = pageNum===0?res.data: this.articles.concat(res.data);
      catalog.articles = this.articles;
      // currentSearchCount = res.data.length;
    }).catch(err => {
      this.isActive = false;
      // currentSearchCount = 0
      console.log('getArticles Error: ', err);
    }).finally(() => {
      // if (pageNum !== 0) {
      //   const contentDiv = (this.$refs.content as HTMLDivElement)
      //   if (contentDiv) {
      //     contentDiv.scrollTop = (contentDiv.querySelector('.cell')?.clientHeight || 0) * currentSearchCount * pageNum
      //   }
      // }
    });
  }
  mounted() {
    this.isMounted = true
    if (this.catalog && this.categories.length) {
      this.itemtype = (this.categories[0].title) as string;
      this.setupData()
    }
  }

  setupData() {
    if (this.categories.length === 1 && this.categories[0].title === '培训中心') {
      this.needShowNav = false;
    }

    for (let index = 0; index < this.categories.length; index++) {
      const element: AbsCatalog = this.categories[index];
      if (element.selected) {
        window.sessionStorage.setItem('currentCatalog', element.title??'')
        this.selectedCategoryIndex = index;
        break;
      }
    }

    setTimeout(this.setupUI, 50);
  }

  setupUI() {
    // const windowHeight = window.document.documentElement.clientHeight;
    const windowWidth = window.document.documentElement.clientWidth;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this

    // const height: number = windowHeight - (window.document.querySelector('.nav')?.clientHeight ?? 0);
    // window.document.querySelector('.content')?.setAttribute('style', `height: ${height}px;`);

    const navCatWidth: number = window.document.querySelector('.catalogs')?.scrollWidth || 0;
    this.needShowPad = navCatWidth > windowWidth;

    this.onSelectedCategoryChanged(this.selectedCategory, {id:-1});

    setTimeout(() => {
      self.scrollInto(self.selectedCategoryIndex);
    }, 50);
    setTimeout(() => {
      const cachedScrollPosition = sessionStorage.getItem('CACHE_SCROLL_BEFORE_KB_SEARCH')
      if (cachedScrollPosition) {
        const parsedScrollPosition = JSON.parse(cachedScrollPosition)
        if (parsedScrollPosition.page > 0) {
          self.getData(self.selectedCategory, 0, (parsedScrollPosition.page + 1) * DEFAULT_PAGE_SIZE)
          .then(() => {
            self.page = parsedScrollPosition.page;
              (self.$parent?.$refs.kbContainer as HTMLElement).scrollTo({ top: Number(parsedScrollPosition.top), behavior: 'smooth' })
          }
          )
        } else if (parsedScrollPosition.top){
          (self.$parent?.$refs.kbContainer as HTMLElement).scrollTo({ top: Number(parsedScrollPosition.top), behavior: 'smooth' });
        }
        sessionStorage.removeItem('CACHE_SCROLL_BEFORE_KB_SEARCH')
      }
    }, 100);
  }

  selectId(id: number): void {
    const index = this.categories.map(c => c.id).indexOf(id);
    this.selectIndex(index);
  }

  selectIndex(index: number): void {
    if (index >= 0 && index < this.categories.length) {
      this.itemtype = (this.categories[index].title) as string;
      this.showPad = false;
      this.$emit('showPad', this.showPad)
      this.categories[this.selectedCategoryIndex].selected = false;
      this.selectedCategoryIndex = index;
      this.categories[index].selected = true;
      this.scrollInto(index);
      (this.$refs.articleList as ArticleList).scrollToTop();
      this.tracking({ isAction: true, pageName: 'KB', prePageName: 'Home', actionName: `menu_selected_${this.categories[index].title}` });
      setTimeout(() => {
        this.scrollInto(this.selectedCategoryIndex);
      }, 50);
    }
  }

  scrollInto(index: number) {
    const element = window.document.querySelector(`#category-${index}`) as HTMLElement;
    if (element && element.scrollIntoView) {
      element.scrollIntoView({ inline: 'center', behavior: 'smooth' }); 
    }
  }
  loadMore() {
    this.page = this.page + 1;
    this.getData(this.selectedCategory, this.page)
  }
}
